import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const StyledIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.addButton.textHover};
  height: 2.4rem;

  @media screen and (max-width: ${({ theme }) => theme.sizes.sm}) {
    height: 2.1rem;
  }
`;

export const StyledBody = styled.div`
  display: grid;
  gap: 2.4rem;
`;

export const StyledBodyText = styled.div`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme }) => theme.colors.text.lighter};
`;

export const StyledTextIcon = styled(FontAwesomeIcon)<{ iconcolour?: string }>`
  color: ${({ theme, iconcolour }) => iconcolour || theme.colors.success.main};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
`;

export const StyledText = styled.div`
  margin-bottom: 1.6rem;
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme }) => theme.colors.text.lighter};
`;

export const StyledTextFieldContainer = styled.div`
  display: grid;
  gap: 2.4rem;
`;
